export default __webpack_public_path__ + "static/media/HomeLaptopblurred.80fe9b86.jpg";